import { css, Global, withTheme } from '@emotion/react'
import * as React from 'react'

const GlobalStyles = withTheme(({ theme }) => (
  <Global
    styles={css`
      .narrow {
        max-width: 775px;
        &.medium {
          max-width: 1000px;
        }
      }

      .center-text {
        text-align: center;
      }

      .center-desktop {
        @media (min-width: 768px) {
          text-align: center;
        }
      }

      .logo {
        max-width: 70px;
        display: block;
      }

      .leshen-header {
        padding: 20px;
        display: block !important;

        .bottom-bar {
          @media (max-width: 1288px) {
            padding-right: 20px !important;
            padding-left: 20px !important;
          }
        }
      }

      .leshen-footer {
        .top-section {
          img {
            max-width: 70px;
          }
        }
      }

      @media screen and (min-width: ${theme.breakpoints.lg}) {
        .leshen-header-mobile {
          display: none !important;
        }
      }

      @media screen and (max-width: ${theme.breakpoints.lg}) {
        .leshen-header {
          display: none !important;
        }

        .leshen-header-mobile {
          display: flex !important;
        }
      }

      .red-link {
        color: #e10b3b !important;

        &:visited {
          color: #e10b3b !important;
        }
      }

      .info-cards {
        img {
          width: unset !important;
          margin: 0 auto;
        }
      }

      .canales-banner {
        div {
          display: flex;
          justify-content: center;

          a {
            padding: 8px 16px;
            text-decoration: none !important;
            color: #fff !important;
            border-radius: 4px;
            font-size: 24px !important;
            transition: all 0.3s;

            &:hover {
              color: #000 !important;
              background-color: #fff;
            }

            @media (max-width: 768px) {
              font-size: 14px !important;
            }
          }
        }

        .text-content {
          display: none;
        }
      }
    `}
  />
))

export default GlobalStyles
